var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSzeneLaden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Szene-Laden__Icn/40px/Szene-Laden",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Szene-Laden__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Szene-Laden__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21,18 L20.9993841,27.568 L23.4826655,25.0857864 L24.8968791,26.5 L19.9471316,31.4497475 L14.9973841,26.5 L16.4115977,25.0857864 L18.9993841,27.674 L19,18 L21,18 Z M19,8 C22.1123823,8 24.7503405,10.1763405 25.6603194,13.1849389 C26.0895182,13.0644395 26.5421018,13 27.0097067,13 C29.7657696,13 32,15.2385763 32,18 C32,20.7614237 29.7657696,23 27.0097067,23 L25,23 L25,21 L27.0097067,21 L27.1853224,20.9949105 C28.7543112,20.9037207 30,19.5985189 30,18 C30,16.3422767 28.6603291,15 27.0097067,15 C26.7318316,15 26.4609402,15.0374892 26.2009258,15.1104893 L24.3135132,15.6403884 L23.7459675,13.7639526 L23.6713255,13.5342671 C22.9342026,11.4153601 21.0748669,10 19,10 C16.6446751,10 14.5865805,11.8235688 14.1045014,14.3752953 L13.7887294,16.0467295 L11.9307343,15.9993501 L11.8025181,16.0054328 C10.8650147,16.0935995 10,17.1307421 10,18.5 C10,19.8874559 10.8935057,20.9436363 11.896474,20.9977113 L12.0354961,21.0007231 L15,21 L15,23 L11.9817183,23 L11.7888005,22.9948108 C9.67935483,22.8810801 8,20.9121849 8,18.5 C8,16.0147186 9.78267602,14 11.9817183,14 L12.1392653,14.0040175 C12.7863941,10.5786556 15.6121343,8 19,8 Z",
    id: ".._.._src_svg_Icn_40px_Szene-Laden__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSzeneLaden);
export default __webpack_public_path__ + "static/media/Szene-Laden.4e5a66c8d9c2426d99a7207db059a581.svg";
export { ForwardRef as ReactComponent };